import React from "react";
import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export interface CheckBoxProps {
    props: {
        pageName: string; // 画面名
        checked: string; // チェック状態
        onChange: (event: React.ChangeEvent<HTMLInputElement>, id: string) => void; // 状態変更時のコールバック関数
    }
}

const ConfirmCheckBox: React.FC<CheckBoxProps> = ({ props }) => {
    //チェックボックスのチェック状態(0=false 1=true)
    const checked: boolean = props.checked === "0" ? false : true;

    // チェックボックスの変更ハンドラー
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        props.onChange(event, props.pageName);
    };

    return (
        <Box>
            <Checkbox
                checked={checked}
                onChange={handleChange}
                sx={{
                    "&.Mui-disabled": {
                        color: "#e0e0e0", // 無効時の色
                    },
                }}
            />
        </Box>
    );
};

export default ConfirmCheckBox;
